import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MediaQueryContext, ThemeContext } from "../../../context";
import Slider from "react-slick";
import {
  Executive_Leadership,
  Research_Leadership,
  Advisory_Board,
} from "./HeringsTeamMember";

import { ReactComponent as TeamListArrowPrev } from "../../../assets/images/02about_herings_team/chevron_left.svg";
import { ReactComponent as TeamListArrowNext } from "../../../assets/images/02about_herings_team/chevron_right.svg";
// import TeamListArrowPrev from "../../../assets/images/etc/team_left.svg";
//import TeamListArrowNext from "../../../assets/images/etc/team_right.svg";
//import topSlideArrowPrev from "../../../assets/images/etc/chevron_left.svg";
//import topSlideArrowNext from "../../../assets/images/etc/chevron_right.svg";
// import CommonCardTitle from "../../common/CommonCardTitle";

import "../Aboutus.css";
import "../slick.css";
import CommonCardTitle from "../../common/CommonCardTitle";
import deptStructure from "../../../assets/images/02about_herings_team/dept_structure.png";

function PrevArrow(props) {
  const { className, style, onClick, matches } = props;
  return (
    <div
      className={className}
      style={({ ...style }, { display: matches ? "none" : "block" })}
      onClick={onClick}
    >
      <TeamListArrowPrev style={{ fill: "#F0F" }} />
    </div>
  );
}

function NextArrow(props) {
  const { className, style, onClick, matches } = props;
  return (
    <div
      className={className}
      style={({ ...style }, { display: matches ? "none" : "block" })}
      onClick={onClick}
    >
      <TeamListArrowNext style={{ fill: "#e6e9ed" }} />
    </div>
  );
}

// class component에서 function component로 변경 (08.01)
export default function TeamList(props) {
  const { sTablet, mobile, mTablet } = useContext(MediaQueryContext);
  const { i18n } = useTranslation();
  // 국문판에서는 한국 분들의 이름을 한글로 표기 (nameKr이 있는 경우)
  // "Myung-Ju Ahn, MD, Ph.D." -> 이름 "안명주" / 학위 "MD, Ph.D."
  const splitName = (team) => {
    const parts = (team.name || "").split(",");
    const degrees = parts.slice(1).join(",").trim();
    const base = i18n.language === "kr" && team.nameKr ? team.nameKr : parts[0].trim();
    return { name: base, degrees };
  };
  const displayName = (team) => splitName(team).name;
  const theme = useContext(ThemeContext);
  const [imgZoom, setImgZoom] = useState(false);

  const LeaderShipSettings = {
    dots: false,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: sTablet ? 2 : 4,
    // slidesToScroll: this.props.matches ? 1 : 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    //arrows: this.props.matches ? false : true,
    nextArrow: <NextArrow matches={sTablet} />,
    prevArrow: <PrevArrow matches={sTablet} />,
  };

  const HERINGS_TEAM_LIST = [
    Executive_Leadership,
    Research_Leadership,
    // Advisory_Board,
  ];
  const ListTitle = [
    "EXECUTIVE_LEADERSHIP",
    "RESEARCH_PARTNERS",
    // "ADVISORY_BOARD",
  ];
  const renderCard = (team, index, groupIdx) => (
    <div key={index} className={`teamDivWrap ${index === 0 ? "ml-0" : ""}`}>
      <div
        className={team.jobs === "None" ? "none" : "heringsTeamWrap m-reset"}
        onClick={() => props.handleOpen(team)}
      >
        <div className="align-items-center justify-center flex w-full">
          <img className="listImg" src={team.modalimg} alt={displayName(team)} />
        </div>
        <div className="heringsTeamContentText">
          <span
            className={`${mobile ? "FontR" : "FontB"} textF18 ${
              theme === "dark" ? "tcw" : "tcb"
            }`}
          >
            {displayName(team)}
          </span>
          {(() => {
            const { degrees } = splitName(team);
            const lines = [degrees, groupIdx === 0 ? team.jobs : ""].filter(Boolean);
            return lines.map((line, i) => (
              <span className="tco textF16 FontR" key={i}>
                {line}
              </span>
            ));
          })()}
        </div>
      </div>
    </div>
  );

  return (
    <div className="aboutuscontents  ">
      {/* <div className="pt-10" /> */}
      {/* <CommonCardTitle title="HERINGS TEAM" fontSize="textF28" tc={0} /> */}{" "}
      <div className="aboutustitle">
        <CommonCardTitle
          title={"HERINGS TEAM"}
          fontStyle={"FontCB"}
          fontSize={"textF40"}
        />
      </div>
      {HERINGS_TEAM_LIST.map((LIST, idx) => (
        <div className="TeamListWrap" key={idx}>
          <div className="Subtitle">
            <span className="FontB tco3 textF28">
              {ListTitle[idx].split("_")[0]}
            </span>
            <span className="FontR tcb textF28">
              {ListTitle[idx].split("_")[1]}
            </span>
          </div>
          {LIST.length <= (sTablet ? 2 : 4) ? (
            <div className="teamStaticRow">
              {LIST.map((team, index) => renderCard(team, index, idx))}
            </div>
          ) : (
            <Slider {...LeaderShipSettings} className="listWrap">
              {LIST.map((team, index) => renderCard(team, index, idx))}
            </Slider>
          )}
        </div>
      ))}
      <div className="deptStructureWrap">
        <img
          src={deptStructure}
          alt="Organization Chart"
          className="deptStructureImg"
          style={{ cursor: mTablet ? "zoom-in" : "default" }}
          onClick={() => mTablet && setImgZoom(true)}
        />
      </div>
      {imgZoom && (
        <div
          className="deptStructureOverlay"
          onClick={() => setImgZoom(false)}
        >
          <img
            src={deptStructure}
            alt="Organization Chart"
            className="deptStructureZoom"
          />
        </div>
      )}
    </div>
  );
}
